var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./shipment-evaluatePackage-view.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-a956abb0\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./shipment-evaluatePackage-view.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/shipment-evaluatePackage-view.vue
// module id = 1833
// module chunks = 1